"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _EntityVersionItem = _interopRequireDefault(require("./EntityVersionItem"));
var _FolderItem = _interopRequireDefault(require("./FolderItem"));
var _TransmittalDocumentItem = _interopRequireDefault(require("./TransmittalDocumentItem"));
var _utils = require("../utils");
/**
 * [Model] Document entity info
 */
var EntityItem = exports["default"] = /*#__PURE__*/function () {
  function EntityItem() {
    (0, _classCallCheck2["default"])(this, EntityItem);
  }
  return (0, _createClass2["default"])(EntityItem, null, [{
    key: "parseV2",
    value:
    /**
     * Parse camel case data
     */
    function parseV2(data) {
      var rowData = data || {};
      var entity = new EntityItem();
      entity.id = rowData.id;
      entity.createTime = _utils.DateUtil.dateStringReformat(rowData.createTime);
      entity.createUserId = rowData.createUserId;
      entity.createUserName = rowData.createUserName;
      entity.currentVersionUrn = rowData.currentVersionUrn;
      entity.description = rowData.description;
      entity.fileName = _utils.FileUtil.decodeFileName(rowData.fileName);
      entity.hidden = rowData.hidden;
      entity.lastModifiedTime = _utils.DateUtil.dateStringReformat(rowData.lastModifiedTime);
      entity.lastModifiedUserId = rowData.lastModifiedUserId;
      entity.lastModifiedUserName = rowData.lastModifiedUserName;
      entity.latestVersion = Number(rowData.latestVersion) || _utils.FileUtil.getVersionNumber(rowData.tipVersionUrn);
      entity.moveState = rowData.moveState;
      entity.name = _utils.FileUtil.decodeFileName(rowData.name);
      entity.originFolderUrn = rowData.originFolderUrn;
      entity.parentFolderUrn = rowData.parentFolderUrn;
      entity.reserved = rowData.reserved;
      entity.reservedAt = _utils.DateUtil.dateStringReformat(rowData.reservedAt);
      entity.reservedUserId = rowData.reservedUserId;
      entity.reservedUserName = rowData.reservedUserName;
      entity.tipVersionUrn = rowData.tipVersionUrn;
      entity.urn = rowData.urn;
      entity.version = _EntityVersionItem["default"].parseV2(rowData.version);
      if (rowData.parentFolder) entity.parentFolder = _utils.FolderUtil.localizeFolderPath(rowData.parentFolder);

      // props for transmittal
      entity.transmittalDocumentEntity = rowData.transmittalDocumentEntity ? _TransmittalDocumentItem["default"].parseV2(rowData.transmittalDocumentEntity) : null;
      (0, _extends2["default"])(entity, _utils.FileUtil.getEntityUpdateInfo(entity));
      return entity;
    }

    /**
     * Parse snake case data
     */
  }, {
    key: "parseV1",
    value: function parseV1(data) {
      var rowData = data || {};
      var entity = new EntityItem();
      entity.id = rowData.id;
      entity.createTime = _utils.DateUtil.dateStringReformat(rowData.create_time);
      entity.createUserId = rowData.create_user_id;
      entity.createUserName = rowData.create_user_name;
      entity.currentVersionUrn = rowData.current_version_urn;
      entity.description = rowData.description;
      entity.fileName = rowData.file_name;
      entity.lastModifiedTime = _utils.DateUtil.dateStringReformat(rowData.last_modified_time);
      entity.lastModifiedUserId = rowData.last_modified_user_id;
      entity.lastModifiedUserName = rowData.last_modified_user_name;
      entity.latestVersion = rowData.latest_version;
      entity.moveState = rowData.move_state;
      entity.name = rowData.name;
      entity.originFolderUrn = rowData.origin_folder_urn;
      entity.parentFolderUrn = rowData.parent_folder_urn;
      entity.processState = rowData.process_state;
      entity.reserved = rowData.reserved;
      entity.reservedAt = _utils.DateUtil.dateStringReformat(rowData.reserved_at);
      entity.reservedUserId = rowData.reserved_user_id;
      entity.reservedUserName = rowData.reserved_user_name;
      entity.urn = rowData.urn;
      entity.version = _EntityVersionItem["default"].parseV1((0, _extends2["default"])({}, rowData.current_version, {
        conforming_status: rowData.conforming_status
      }));
      entity.tipVersionUrn = _utils.FileUtil.getTipVersionUrn(entity);
      (0, _extends2["default"])(entity, _utils.FileUtil.getEntityUpdateInfo(entity));
      return entity;
    }

    /**
     * Parse camel case data
     */
  }, {
    key: "parseV3",
    value: function parseV3(data) {
      var _rowData$includedVers;
      var rowData = data || {};
      var entity = new EntityItem();
      entity.id = rowData.id;
      entity.urn = rowData.urn;
      entity.createTime = _utils.DateUtil.dateStringReformat(rowData.createdAt);
      entity.createUserId = rowData.createdBy;
      entity.createUserName = rowData.createdByName;
      entity.lastModifiedTime = _utils.DateUtil.dateStringReformat(rowData.updatedAt);
      entity.lastModifiedUserId = rowData.updatedBy;
      entity.lastModifiedUserName = rowData.updatedByName;
      entity.latestVersion = Number(rowData.latestVersion) || _utils.FileUtil.getVersionNumber(rowData.tipVersionUrn);
      entity.currentVersionUrn = rowData.currentVersionUrn || ((_rowData$includedVers = rowData.includedVersion) === null || _rowData$includedVers === void 0 ? void 0 : _rowData$includedVers.urn);
      entity.reserved = rowData.reserved;
      entity.reservedAt = _utils.DateUtil.dateStringReformat(rowData.reservedAt);
      entity.reservedUserId = rowData.reservedBy;
      entity.reservedUserName = rowData.reservedByName;
      entity.name = rowData.name; // Lineage won't have the name field, it's using the same value from the tip version name.
      entity.description = rowData.description;
      entity.tipVersionUrn = rowData.tipVersionUrn;
      entity.parentFolderUrn = rowData.parentFolderUrn;

      // Newly added
      entity.hidden = rowData.hidden;
      entity.trashed = rowData.trashed;
      entity.entityType = rowData.entityType;
      entity.action = rowData.action;

      // Version
      entity.version = _EntityVersionItem["default"].parseV3(rowData.includedVersion);

      // Values mapped from version
      entity.fileName = entity.version.fileName;

      // Added for parsing search entity
      if (rowData.parentFolder) entity.parentFolder = _FolderItem["default"].parseV3(rowData.parentFolder);
      entity.highlights = rowData.highlights;

      // Added for pdf extraction indicator
      entity.processToFileLastVersionUrn = rowData.processToFileLastVersionUrn;
      (0, _extends2["default"])(entity, _utils.FileUtil.getEntityUpdateInfo(entity));
      return entity;
    }
  }]);
}();